import Analytics from '@utils/Analytics'

const initialState = {
  analytics: new Analytics()
}

const reducer = (state = initialState, action) => {
  const { type } = action

  switch (type) {
  default:
    return state
  }
}

export default reducer
